module.exports = __webpack_public_path__ + "static/live-room-8-97e5e945839718ef5729769358952c6f.jpg";